// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.
import './unread_message_channel'
import './sample_request_channel'
import './information_request_channel'
import './pricing_request_channel'

const channels = require.context('.', true, /_channel\.js$/)
channels.keys().forEach(channels)
